export interface BuildSitesAdvancedQueryOptions {
  sitesSource?: string;
  latitude?: number;
  longitude?: number;
  distanceMiles?: number;
  sortByDistance?: boolean;
  communities?: string[];
  /** Preferred / saved site IDs matched against @site_id */
  siteIds?: string[];
}

const escapeCoveoFieldValue = (value: string): string =>
  value.replace(/\\/g, '\\\\').replace(/"/g, '\\"');

export const buildSitesAdvancedQuery = ({
  sitesSource = process.env.NEXT_PUBLIC_COVEO_SITES_SOURCE || 'Avacare Protocol Sites - Dev',
  latitude,
  longitude,
  distanceMiles,
  sortByDistance = false,
  communities,
  siteIds,
}: BuildSitesAdvancedQueryOptions = {}): string => {
  let aq = `@source="${sitesSource}"`;

  const communityFilters = (communities ?? []).map((value) => value.trim()).filter(Boolean);
  if (communityFilters.length > 0) {
    const quoted = communityFilters.map((value) => `"${escapeCoveoFieldValue(value)}"`).join(',');
    aq += ` @site_relatedcommunities==(${quoted})`;
  }

  const siteIdFilters = (siteIds ?? []).map((value) => value.trim()).filter(Boolean);
  if (siteIdFilters.length > 0) {
    const orClause = siteIdFilters
      .map((id) => `@site_id=="${escapeCoveoFieldValue(id)}"`)
      .join(' OR ');
    aq += ` (${orClause})`;
  }

  const hasCoordinates = latitude != null && longitude != null;

  if (hasCoordinates) {
    // Compute @distance for display even when not sorting by distance (e.g. SavedSiteCarousel).
    aq += ` $qf(function:'dist(@site_lattitude, @site_longitude, ${latitude}, ${longitude})*0.000621371', fieldName: 'distance')`;

    if (sortByDistance) {
      // Radius filter only when an explicit distance is provided (not on default page load).
      if (distanceMiles != null) {
        aq += ` @distance<=${distanceMiles}`;
      }
      aq += ` $sort(criteria: 'fieldascending', field: '@distance')`;
    }
  }

  return aq;
};
